module.exports = __webpack_public_path__ + "img/frame (67).e429d309.jpg";